export const blockIconsEditorFunctions = (
	<span className='material-symbols-outlined'>functions</span>
);
